"use client";
// biome-ignore lint: React in this context is used throughout, so biome will change to types because no APIs are used even though React is needed.
import * as React from "react";
import type { ComponentProps } from "react";
import { cn } from "../../lib/utils";

type ModifierKey = "⌘" | "⇧" | "CTRL" | "⌥";

interface KeyboardButtonProps extends ComponentProps<"span"> {
  shortcut: string;
  modifierKey?: ModifierKey | null;
}

const KeyboardButton = ({
  shortcut,
  modifierKey,
  className = "",
  ...props
}: KeyboardButtonProps) => {
  return (
    <span
      tabIndex={-1}
      className={cn(
        "flex items-center justify-center h-5 px-1 min-w-[24px] text-xs",
        "bg-gray-3 text-gray-12 border border-strong rounded-md hover:bg-grayA-4 focus:hover:bg-transparent",
        "focus:border-accent-8 focus:ring-4 focus:ring-accentA-5 focus-visible:outline-hidden focus:ring-offset-0",
        "disabled:border disabled:border-grayA-4 disabled:text-grayA-7",
        "active:bg-grayA-5 max-md:hidden",
        className,
      )}
      aria-label={`Keyboard shortcut ${modifierKey || ""} ${shortcut}`}
      role="presentation"
      aria-haspopup="true"
      title={`Press '${modifierKey ?? ""}${shortcut?.toUpperCase()}' to toggle`}
      {...props}
    >
      {/* className="not-prose" added to prevent markdown rendering issues */}
      {modifierKey && <kbd className="not-prose">{modifierKey}+</kbd>}
      <kbd className="not-prose">{shortcut?.toUpperCase()}</kbd>
    </span>
  );
};

KeyboardButton.displayName = "KeyboardButton";

export { KeyboardButton };
